var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingR3 = function SvgEarRingR3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 28,
    height: 30,
    viewBox: "0 0 0.64 0.69",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2316546742368"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.09.15C.14.04.39 0 .47.17M.5.38C.5.51.47.59.3.63.24.64.07.64.06.56M.34.27C.26.24.1.33.22.36.29.38.29.44.18.44.17.44.15.45.14.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.57.16C.63.2.64.24.64.29.63.32.61.35.59.36.57.38.53.39.5.39.46.38.42.35.4.29.38.21.42.19.46.17h.01V.16C.48.16.5.15.51.15c.02 0 .05 0 .06.01zM.54.22C.63.28.5.38.47.27.46.24.48.23.51.22h.03z",
    fill: "#000"
  })))));
};

export default SvgEarRingR3;